/**
 * Third-party endpoints that are noise in frontend telemetry: error
 * reporting (Sentry), map tiles and geocoding (Mapbox), and the Logto OIDC
 * endpoints, whose query strings carry authorisation codes.
 */
export const DEFAULT_IGNORED_URLS = [
    /\.sentry\.io\//,
    /api\.mapbox\.com\//,
    /events\.mapbox\.com\//,
    /\/oidc\//,
];
export const DEFAULT_SESSION_SAMPLE_RATE = 1;
function normaliseSampleRate(sampleRate) {
    if (sampleRate === undefined || !Number.isFinite(sampleRate))
        return DEFAULT_SESSION_SAMPLE_RATE;
    return Math.min(1, Math.max(0, sampleRate));
}
function optionalValue(value) {
    const trimmed = value?.trim() ?? "";
    return trimmed.length > 0 ? trimmed : undefined;
}
/**
 * Validates and completes the options. Returns null when Faro is disabled
 * (no collector URL).
 */
export function resolveFaroSettings(options) {
    const collectorUrl = optionalValue(options.collectorUrl);
    if (!collectorUrl)
        return null;
    return {
        collectorUrl,
        app: {
            name: options.appName,
            version: optionalValue(options.appVersion),
            environment: optionalValue(options.environment),
        },
        traceCorsUrls: [...(options.traceCorsUrls ?? [])],
        sessionSampleRate: normaliseSampleRate(options.sessionSampleRate),
        ignoreUrls: [...DEFAULT_IGNORED_URLS, ...(options.ignoreUrls ?? [])],
        tracingEnabled: options.enableTracing ?? true,
    };
}
//# sourceMappingURL=options.js.map